module.exports = __webpack_public_path__ + "img/404.1514e65f.png";